import { NgModule } from '@angular/core';
import { CmsConfig, I18nConfig, provideConfig } from 'haba-core';
import {
  userAccountTranslationChunksConfig,
  userAccountTranslations,
} from 'haba-featurelibs/user/account/assets';
import { UserAccountRootModule, USER_ACCOUNT_FEATURE } from 'haba-featurelibs/user/account/root';
import {
  userProfileTranslationChunksConfig,
  userProfileTranslations,
} from 'haba-featurelibs/user/profile/assets';
import { UserProfileRootModule, USER_PROFILE_FEATURE } from 'haba-featurelibs/user/profile/root';

@NgModule({
  declarations: [],
  imports: [UserAccountRootModule, UserProfileRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [USER_ACCOUNT_FEATURE]: {
          module: () => import('haba-featurelibs/user/account').then((m) => m.UserAccountModule),
        },
        UserModule: {
          module: () => import('./user.module').then((m) => m.UserModule),
          cmsComponents: [
            'ForgotPasswordComponent',
            'ReturningCustomerLoginComponent',
            'ResetPasswordComponent',
            'AccountOverviewAvatarComponent',
            'AccountOverviewSideNav1Component',
            'UpdatePasswordComponent',
            'UpdateEmailComponent',
            'AccountOrderHistoryComponent',
            'AccountOrderDetailsActionsComponent',
            'AccountOrderDetailsItemsComponent',
            'AccountOrderDetailsTotalsComponent',
            'AccountOrderDetailsShippingComponent',
            'RegistrationPendingComponent',
          ],
        },
      },
      routing: {
        routes: {
          profile: { paths: ['my-account/profile'] },
          myAccountOverview: { paths: ['my-account'] },
          myAccountUpdateCustomerData: { paths: ['my-account/update-customer-data'] },
          myAccountUpdateCompanyData: { paths: ['my-account/update-company-data'] },
          myAccountMyOrders: { paths: ['my-account/my-orders'] },
          myAccountLoginData: { paths: ['my-account/login-data'] },
          myAccountDeliveryAddress: { paths: ['my-account/delivery-address'] },
          myAccountBillingAddress: { paths: ['my-account/billing-address'] },
          contact: { paths: ['s/service-vorteile/kontakt'] },
          registrationPending: { paths: ['login/registration-pending'] },
          productAdvisor: { paths: ['product-advisor'] },
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: userAccountTranslations,
        chunks: userAccountTranslationChunksConfig,
      },
    }),
    provideConfig(<CmsConfig>{
      featureModules: {
        [USER_PROFILE_FEATURE]: {
          module: () => import('haba-featurelibs/user/profile').then((m) => m.UserProfileModule),
        },
      },
    }),
    provideConfig(<I18nConfig>{
      i18n: {
        resources: userProfileTranslations,
        chunks: userProfileTranslationChunksConfig,
      },
    }),
  ],
})
export class UserFeatureModule {}
